// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon[data-v-1a3c7042]{display:inline-flex;line-height:1}.svg-icon svg[data-v-1a3c7042]{width:1em}", ""]);
// Exports
module.exports = exports;
